import { Box, styled } from '@mui/material'

interface IPageContentProps {
  children: React.ReactNode
}

const StyledContent = styled(Box)(({ theme }) => ({
  maxWidth: 1152,
  margin: '0 auto',
  padding: theme.spacing(4, 6),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}))

export const PageContent = ({ children }: IPageContentProps) => {
  return <StyledContent>{children}</StyledContent>
}
